import(/* webpackMode: "eager" */ "/vercel/path0/src/app/releases/page.tsx");
